compiler('[data-confirmation-modal]', (element) => {
  const DATA_CONFIRMED_ATTRIBUTE = 'data-modal-confirmed'
  const modalContent = element.getAttribute("data-confirmation-modal")
  const modalTitle = element.getAttribute("data-confirmation-modal-title")

  if(modalContent === null || modalContent === ''){
    return
  }

  element.addEventListener('click', (event) => {
    if(element.hasAttribute(DATA_CONFIRMED_ATTRIBUTE)) {
      element.removeAttribute(DATA_CONFIRMED_ATTRIBUTE)
      return
    }

    event.preventDefault()
    event.stopPropagation()

    const modal = DynamicModal.openModal(modalContent, false, { default_title: modalTitle })
    setupModal(modal)
  })

  // Prevent modals from opening, as they can´t be stopped by preventing the click event.
  const onModalOpen = (event) => {
    if (element === event.relatedTarget && !element.hasAttribute(DATA_CONFIRMED_ATTRIBUTE)) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  const modalTarget = document.getElementById('modal_target');
  modalTarget.addEventListener('show.bs.modal', onModalOpen);

  function setupModal(modal) {
    const acceptButton = modal.querySelector("[accept-confirmation]")
    const dismissButton = modal.querySelector("[dismiss-confirmation]")

    acceptButton.addEventListener('click', (event) => {
      bootstrap.Modal.getOrCreateInstance(modal).hide();
      element.setAttribute(DATA_CONFIRMED_ATTRIBUTE, "true")
      element.click()
    })

    dismissButton.addEventListener('click', (event) => {
      bootstrap.Modal.getOrCreateInstance(modal).hide();
    })
  }

  return () => {
    modalTarget.removeEventListener('show.bs.modal', onModalOpen)
  }

})
